import React, { useState, useEffect } from "react";
import Switch from "react-switch";
import Header from "../../../components/layout/header.jsx";
import LeftMenu from "../../../components/layout/leftMenu.jsx";
import { backendApi } from "../../../api/apiService";
import { FaMapPin, FaRupeeSign, FaShoppingBag } from "react-icons/fa";
import { HiStatusOnline } from "react-icons/hi";
import { BsArrowRightCircleFill } from "react-icons/bs";
import { useNavigate } from "react-router-dom";
import { BsCalendar2Date } from "react-icons/bs";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { useSelector } from "../../../components/hooks/hooks";
import { ToastContainer, toast } from "react-toastify";
import {
  FiSearch,
  FiMail,
  FiPhone,
  FiUsers,
  FiCalendar,
  FiMapPin,
} from "react-icons/fi";
import {
  MdPriorityHigh,
  MdOutlineCurrencyRupee,
  MdPeople,
  MdPeopleAlt,
  MdCalendarToday,
  MdFolder,
  MdPerson,
} from "react-icons/md";
import { MapPin } from "react-feather";
import { BsCashStack } from "react-icons/bs";
import { GrUserExpert } from "react-icons/gr";
import { MdOutlineCategory } from "react-icons/md";
import ReactSelect from "react-select";
const RequirementProcessing = () => {
  const { userDetails, userData, userId, siteId } = useSelector(
    (state) => state.login
  );
  const [openings, setOpenings] = useState([]);
  const [newOpenings, setNewOpenings] = useState([]);
  const [menuClick, setMenuClick] = useState(false);
  const [recruitersList, setRecruitersList] = useState([]);
  const [userList, setUserList] = useState([]);
  const [recruiter, setRecruiter] = useState([]);
  const [tabIndex, setTabIndex] = useState(0);
  const [offset, setOffset] = useState(0);

  const navigate = useNavigate();
  useEffect(() => {
    setTimeout(() => {
      document.getElementById("RequirementProcessing").classList.add("active");
    }, 500);
    getOpenings();
    getUserList();
  }, []);

  const getCategoryCount = (candidate, categoryType) => {
    const category = candidate.category.find(
      (cat) => cat.category_type === categoryType
    );
    return category ? category.cnt : 0;
  };

  const getOpenings = () => {
    var req = {
      functionName: "job_opening_Listing",
      site_id: siteId,
      sec_user_id: userId,
    };
    backendApi(req).then((response) => {
      if (response.success === "1") {
        setOpenings(response.skill);
      } else {
        console.error("error while fetching openings");
        return false;
      }
    });
  };

  const getRequirementOpenings = (offset = 0) => {
    const api = {
      functionName: "openingList",
      site_id: siteId,
      sec_user_id: userId,
      offset: offset,
    };
    backendApi(api).then((response) => {
      console.log("🚀 ~ backendApi ~ response:", response);
      if (response.success === "1") {
        setNewOpenings(response.yourdata);
      }
    });
  };
  function formatDate(dateString) {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }

  function formatDateToCustomFormat(dateString) {
    const options = {
      year: "numeric",
      month: "short",
      day: "numeric",
    };

    return new Date(dateString).toLocaleDateString("en-GB", options);
  }

  const navigateToOtherPage = (value) => {
    const yourProp = value;
    navigate(`/assignRecruiter`, {
      state: {
        props: yourProp,
      },
    });
  };

  const navigateToTables = (value, category) => {
    const yourProp = value;
    navigate(`/tables`, {
      state: {
        props: yourProp,
        data: category,
      },
    });
  };
  const changeActive = (event, candidate) => {
    setOpenings(
      openings.map((obj) => {
        if (candidate.id === obj.id) {
          return {
            ...obj,
            is_active: event === true ? 1 : 0,
          };
        }
        return obj;
      })
    );
    var req = {
      functionName: "job_opening_active_deactive",
      job_opening_id: candidate.id,
      is_active: event,
    };
    backendApi(req).then((response) => {
      if (response.success !== 1) {
        // setOpenings(response.skill);
        console.error("error while fetching openings");
        return false;
      }
    });
  };
  const publishToWebsite = (event, candidate) => {
    let tempOpenings = openings.map((obj) => {
      if (obj.id === candidate.id) {
        return {
          ...obj,
          publish_to_website: Number(event.target.checked),
        };
      }
      return {
        ...obj,
      };
    });
    setOpenings(tempOpenings);
    const api = {
      functionName: "publishtowebsite",
      is_active: Number(event.target.checked),
      job_opening_id: candidate.id,
      sec_user_id: userId,
    };
    backendApi(api).then((response) => {
      if (response.success === 1) {
        toast.success(
          `${
            event.target.checked === true
              ? "Published to Site"
              : "Removed from Site"
          }`,
          { containerId: "D" }
        );
      } else {
        toast.error("Something went wrong in Publish", {
          containerId: "D",
        });
      }
    });
  };
  const toggleMenu = () => {
    setMenuClick(!menuClick);
  };
  const closeMenu = () => {
    setMenuClick(false);
  };
  //? Function to get User
  const getUserList = () => {
    const api = {
      functionName: "userListing",
      site_id: userDetails[0].site_id,
    };
    backendApi(api).then((response) => {
      if (response.success === "1") {
        const recruiters = response.dataSet
          .filter((obj) => obj.roleId === 1 || obj.roleId === 5)
          .map((m) => ({
            ...m,
            label: `${m.first_name} ${m.last_name}`,
            value: m.id,
          }));
        setRecruitersList(recruiters);
        setUserList(
          response.dataSet.map((m) => ({
            ...m,
            label: `${m.first_name} ${m.last_name}`,
            value: m.id,
          }))
        );
        getRequirementOpenings();
      }
    });
  };

  return (
    <>
      <div className="main-wrapper">
        <div className="top-color"></div>
        <ToastContainer
          enableMultiContainer
          containerId={"D"}
          position="bottom-right"
          autoClose={1500}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="colored"
        />
        <LeftMenu menuClick={menuClick} closeMenu={closeMenu} />
        <div className="content-wrapper">
          <Header
            Header="Recruiters"
            toggleMenu={toggleMenu}
            menuClick={menuClick}
          />
          <div className="main-container">
            <div className="card main-card">
              <div className="card-body">
                <ReactSelect
                  options={recruitersList}
                  value={recruiter}
                  onChange={setRecruiter}
                />
                <Tabs
                  selectedIndex={tabIndex}
                  onSelect={(index) => setTabIndex(index)}
                >
                  <TabList>
                    <Tab>Active</Tab>
                    <Tab>Inactive</Tab>
                  </TabList>
                  <TabPanel>
                    {newOpenings.map((candidate, index) => {
                      const createdBy = userList.filter(
                        (o) => o.value === candidate.created_by
                      )[0].label;
                      return (
                        <div>
                          {candidate.is_active === 1 ? (
                            <div className="card-inner">
                              <div className="row">
                                <div className="col-md-7">
                                  <h4 className="job-view-header">
                                    {candidate.recruitmentSummary}
                                  </h4>
                                  <div className="mb-2">
                                    {/* <span className="label-text">Description :{" "}</span>   */}
                                    <span className="font-Medium ">
                                      {" "}
                                      {candidate.recruitmentRemarks}
                                    </span>
                                  </div>
                                  <div className="flex-result">
                                    <div className="flex-sub-div">
                                      <span className="label-text">
                                        <FiCalendar className="me-1" />
                                      </span>
                                      <span className="font-Medium ">
                                        Created On:{" "}
                                        {formatDateToCustomFormat(
                                          candidate.created_on
                                        )}
                                      </span>
                                    </div>
                                    <div className="flex-sub-div">
                                      <span className="label-text">
                                        <MdCalendarToday className="me-1" />
                                      </span>
                                      <span className="font-Medium ">
                                        Due On:{" "}
                                        {formatDateToCustomFormat(
                                          candidate.due_date
                                        )}
                                      </span>
                                    </div>
                                    <div className="flex-sub-div">
                                      <span className="label-text me-2">
                                        <HiStatusOnline />
                                      </span>
                                      <span className="font-Medium ">
                                        Vacancy Status:{" "}
                                        {candidate.vacancyStatus
                                          ? candidate.vacancyStatus
                                          : " Not Available"}
                                      </span>
                                    </div>
                                    <div className="flex-sub-div">
                                      <span className="label-text me-2">
                                        <GrUserExpert />
                                      </span>
                                      <span className="font-Medium ">
                                        {candidate.filled_vacancy}/
                                        {candidate.no_of_vacancy} Vacancies
                                        filled
                                      </span>
                                    </div>
                                    <div className="flex-sub-div">
                                      <span className="label-text me-2">
                                        <BsCashStack />
                                      </span>
                                      <span className="font-Medium ">
                                        Salary Package:{" "}
                                        {candidate.packageValue
                                          ? candidate.packageValue
                                          : 0}
                                      </span>
                                    </div>
                                    <div className="flex-sub-div">
                                      <span className="label-text me-2">
                                        <MdPeople />
                                      </span>
                                      <span className="font-Medium ">
                                        Managers:{" "}
                                        {candidate.reportingManagers
                                          ? candidate.reportingManagers
                                          : 0}
                                      </span>
                                    </div>
                                    <div className="flex-sub-div">
                                      <span className="label-text me-2">
                                        <MdPriorityHigh />
                                      </span>
                                      <span className="font-Medium ">
                                        Priority:{" "}
                                        {candidate.priority
                                          ? candidate.priority
                                          : 0}
                                        {"  "}
                                      </span>
                                    </div>
                                    <div className="flex-sub-div">
                                      <span className="label-text">
                                        <MdPeopleAlt className="me-2" />
                                      </span>
                                      <span className="font-Medium ">
                                        Assigned Recruiters:{" "}
                                        {candidate.recruiters
                                          ? candidate.recruiters
                                          : "Not Available"}
                                      </span>
                                    </div>
                                    <div className="flex-sub-div">
                                      <span className="label-text">
                                        <MdFolder className="me-2" />
                                      </span>
                                      <span className="font-Medium ">
                                        Project:{" "}
                                        {candidate.projectName
                                          ? candidate.projectName
                                          : "Not Available"}
                                      </span>
                                    </div>
                                    <div className="flex-sub-div">
                                      <span className="label-text">
                                        <FiMapPin className="me-2" />
                                      </span>
                                      <span className="font-Medium ">
                                        Location:{" "}
                                        {candidate.locationName
                                          ? candidate.locationName
                                          : "Not Available"}
                                      </span>
                                    </div>
                                    <div className="flex-sub-div">
                                      <span className="label-text me-2">
                                        <MdPerson />
                                      </span>
                                      <span className="font-Medium ">
                                        Created By: {createdBy}
                                        {"  "}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                {/* <div className="col-md-5 text-right jobopenings-btn text-md-end text-start my-md-0 my-2">
                                  {["ShortListed", "Hired", "Applied"].map(
                                    (categoryType) => {
                                      const count = getCategoryCount(
                                        candidate,
                                        categoryType
                                      );
                                      if (count > 0) {
                                        return (
                                          <div
                                            key={categoryType}
                                            className={`job-view-header ${categoryType.toLowerCase()}-prof`}
                                            onClick={() =>
                                              navigateToTables(
                                                candidate,
                                                categoryType
                                              )
                                            }
                                          >
                                            {categoryType}
                                            <span className="btn-sub-font">
                                              ({count})
                                            </span>
                                          </div>
                                        );
                                      }
                                      return null;
                                    }
                                  )}
                                </div> */}
                              </div>
                              <div className="my-2 mb-3">
                                <label className="font-Medium">
                                  <input
                                    type="checkbox"
                                    id="checkWebsite"
                                    checked={Boolean(
                                      candidate.publish_to_website
                                    )}
                                    className="me-2"
                                    onChange={(e) =>
                                      publishToWebsite(e, candidate)
                                    }
                                  ></input>
                                  Publish to Website
                                </label>
                              </div>

                              <div className="row border-top pt-3 mt-2">
                                <div className="col-md-5">
                                  <div className="flex-result">
                                    <div className="flex-sub-div">
                                      <span className="label-text">
                                        Posted on :{" "}
                                      </span>
                                      <span className="font-Medium ">
                                        {formatDateToCustomFormat(
                                          candidate.created_on
                                        )}
                                      </span>
                                    </div>
                                    <div className="flex-sub-div">
                                      <span className="label-text">
                                        No of Positions :{" "}
                                      </span>
                                      <span className="font-Medium ">
                                        {candidate.no_of_position
                                          ? candidate.no_of_position
                                          : 0}{" "}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-md-7">
                                  <div className="d-flex aling-items-center justify-content-end gap-2">
                                    <Switch
                                      className="switch_case mt-1 mr-2"
                                      handleDiameter={16}
                                      height={18}
                                      width={40}
                                      checked={
                                        candidate.is_active === 1 ? true : false
                                      }
                                      onChange={(checked) => {
                                        changeActive(checked, candidate);
                                      }}
                                    />
                                    <BsArrowRightCircleFill
                                      title="process"
                                      size={26}
                                      onClick={() =>
                                        navigateToOtherPage(candidate)
                                      }
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          ) : (
                            <p>No Requirements Found</p>
                          )}
                        </div>
                      );
                    })}
                  </TabPanel>
                  <TabPanel>
                    {newOpenings.map((candidate, index) => {
                      const createdBy = userList.filter(
                        (o) => o.value === candidate.created_by
                      )[0].label;
                      return (
                        <div>
                          {candidate.is_active === 0 ? (
                            <div className="card-inner">
                              <div className="row">
                                <div className="col-md-7">
                                  <h4 className="job-view-header">
                                    {candidate.recruitmentSummary}
                                  </h4>
                                  <div className="mb-2">
                                    {/* <span className="label-text">Description :{" "}</span>   */}
                                    <span className="font-Medium ">
                                      {" "}
                                      {candidate.recruitmentRemarks}
                                    </span>
                                  </div>
                                  <div className="flex-result">
                                    <div className="flex-sub-div">
                                      <span className="label-text">
                                        <FiCalendar className="me-1" />
                                      </span>
                                      <span className="font-Medium ">
                                        Created On:{" "}
                                        {formatDateToCustomFormat(
                                          candidate.created_on
                                        )}
                                      </span>
                                    </div>
                                    <div className="flex-sub-div">
                                      <span className="label-text">
                                        <MdCalendarToday className="me-1" />
                                      </span>
                                      <span className="font-Medium ">
                                        Due On:{" "}
                                        {formatDateToCustomFormat(
                                          candidate.due_date
                                        )}
                                      </span>
                                    </div>
                                    <div className="flex-sub-div">
                                      <span className="label-text me-2">
                                        <HiStatusOnline />
                                      </span>
                                      <span className="font-Medium ">
                                        Vacancy Status:{" "}
                                        {candidate.vacancyStatus
                                          ? candidate.vacancyStatus
                                          : " Not Available"}
                                      </span>
                                    </div>
                                    <div className="flex-sub-div">
                                      <span className="label-text me-2">
                                        <GrUserExpert />
                                      </span>
                                      <span className="font-Medium ">
                                        {candidate.filled_vacancy}/
                                        {candidate.no_of_vacancy} Vacancies
                                        filled
                                      </span>
                                    </div>
                                    <div className="flex-sub-div">
                                      <span className="label-text me-2">
                                        <BsCashStack />
                                      </span>
                                      <span className="font-Medium ">
                                        Salary Package:{" "}
                                        {candidate.packageValue
                                          ? candidate.packageValue
                                          : 0}
                                      </span>
                                    </div>
                                    <div className="flex-sub-div">
                                      <span className="label-text me-2">
                                        <MdPeople />
                                      </span>
                                      <span className="font-Medium ">
                                        Managers:{" "}
                                        {candidate.reportingManagers
                                          ? candidate.reportingManagers
                                          : 0}
                                      </span>
                                    </div>
                                    <div className="flex-sub-div">
                                      <span className="label-text me-2">
                                        <MdPriorityHigh />
                                      </span>
                                      <span className="font-Medium ">
                                        Priority:{" "}
                                        {candidate.priority
                                          ? candidate.priority
                                          : 0}
                                        {"  "}
                                      </span>
                                    </div>
                                    <div className="flex-sub-div">
                                      <span className="label-text">
                                        <MdPeopleAlt className="me-2" />
                                      </span>
                                      <span className="font-Medium ">
                                        Assigned Recruiters:{" "}
                                        {candidate.recruiters
                                          ? candidate.recruiters
                                          : "Not Available"}
                                      </span>
                                    </div>
                                    <div className="flex-sub-div">
                                      <span className="label-text">
                                        <MdFolder className="me-2" />
                                      </span>
                                      <span className="font-Medium ">
                                        Project:{" "}
                                        {candidate.projectName
                                          ? candidate.projectName
                                          : "Not Available"}
                                      </span>
                                    </div>
                                    <div className="flex-sub-div">
                                      <span className="label-text">
                                        <FiMapPin className="me-2" />
                                      </span>
                                      <span className="font-Medium ">
                                        Location:{" "}
                                        {candidate.locationName
                                          ? candidate.locationName
                                          : "Not Available"}
                                      </span>
                                    </div>
                                    <div className="flex-sub-div">
                                      <span className="label-text me-2">
                                        <MdPerson />
                                      </span>
                                      <span className="font-Medium ">
                                        Created By: {createdBy}
                                        {"  "}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                {/* <div className="col-md-5 text-right jobopenings-btn text-md-end text-start my-md-0 my-2">
                                  {["ShortListed", "Hired", "Applied"].map(
                                    (categoryType) => {
                                      const count = getCategoryCount(
                                        candidate,
                                        categoryType
                                      );
                                      if (count > 0) {
                                        return (
                                          <div
                                            key={categoryType}
                                            className={`job-view-header ${categoryType.toLowerCase()}-prof`}
                                            onClick={() =>
                                              navigateToTables(
                                                candidate,
                                                categoryType
                                              )
                                            }
                                          >
                                            {categoryType}
                                            <span className="btn-sub-font">
                                              ({count})
                                            </span>
                                          </div>
                                        );
                                      }
                                      return null;
                                    }
                                  )}
                                </div> */}
                              </div>
                              <div className="my-2 mb-3">
                                <label className="font-Medium">
                                  <input
                                    type="checkbox"
                                    id="checkWebsite"
                                    checked={Boolean(
                                      candidate.publish_to_website
                                    )}
                                    className="me-2"
                                    onChange={(e) =>
                                      publishToWebsite(e, candidate)
                                    }
                                  ></input>
                                  Publish to Website
                                </label>
                              </div>

                              <div className="row border-top pt-3 mt-2">
                                <div className="col-md-5">
                                  <div className="flex-result">
                                    <div className="flex-sub-div">
                                      <span className="label-text">
                                        Posted on :{" "}
                                      </span>
                                      <span className="font-Medium ">
                                        {formatDateToCustomFormat(
                                          candidate.created_on
                                        )}
                                      </span>
                                    </div>
                                    <div className="flex-sub-div">
                                      <span className="label-text">
                                        No of Positions :{" "}
                                      </span>
                                      <span className="font-Medium ">
                                        {candidate.no_of_position
                                          ? candidate.no_of_position
                                          : 0}{" "}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-md-7">
                                  <div className="d-flex aling-items-center justify-content-end gap-2">
                                    <Switch
                                      className="switch_case mt-1 mr-2"
                                      handleDiameter={16}
                                      height={18}
                                      width={40}
                                      checked={
                                        candidate.is_active === 1 ? true : false
                                      }
                                      onChange={(checked) => {
                                        changeActive(checked, candidate);
                                      }}
                                    />
                                    <BsArrowRightCircleFill
                                      title="process"
                                      size={26}
                                      onClick={() =>
                                        navigateToOtherPage(candidate)
                                      }
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          ) : (
                            <p>No Requirements Found</p>
                          )}
                        </div>
                      );
                    })}
                  </TabPanel>
                </Tabs>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default RequirementProcessing;
